(() => {
  const rootSelector = '[data-sogna-backorder-root]';

  const pushEvent = (eventName, root) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      product_id: root.dataset.productId,
      variant_id: root.dataset.variantId
    });
  };

  const createRequestSuffix = () => {
    if (window.crypto?.getRandomValues) {
      const values = new Uint32Array(1);
      window.crypto.getRandomValues(values);
      return values[0].toString(36).toUpperCase().slice(0, 6);
    }

    return Math.random().toString(36).slice(2, 8).toUpperCase();
  };

  const setPanelState = (root, open, options = {}) => {
    const toggle = root.querySelector('[data-sogna-backorder-toggle]');
    const panel = root.querySelector('[data-sogna-backorder-panel]');

    if (!toggle || !panel) return;

    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    root.classList.toggle('is-open', open);

    if (!open) return;

    if (!root.dataset.openTracked) {
      pushEvent('backorder_request_open', root);
      root.dataset.openTracked = 'true';
    }

    if (options.scroll) {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      root.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
    }

    if (options.focus) {
      window.setTimeout(() => {
        const result = panel.querySelector('[data-sogna-backorder-result]');
        const firstField = panel.querySelector('input:not([type="hidden"]), select, textarea');
        (result || firstField)?.focus({ preventScroll: true });
      }, options.scroll ? 350 : 0);
    }
  };

  const initialiseRoot = (root) => {
    if (root.dataset.sognaBackorderInitialised) return;

    root.dataset.sognaBackorderInitialised = 'true';

    const eventDate = root.querySelector('input[type="date"]');
    if (eventDate) {
      const now = new Date();
      const localToday = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
      eventDate.min = localToday;
    }

    const requestId = root.querySelector('[data-sogna-backorder-request-id]');
    if (requestId && !requestId.value.endsWith('-TEST')) {
      requestId.value = `${requestId.value}-${createRequestSuffix()}`;
    }

    if (root.querySelector('[data-sogna-backorder-result]')) {
      setPanelState(root, true, { focus: true, scroll: true });
    }
  };

  const bindRerenderGuard = (rerender) => {
    if (!rerender.hasAttribute('allow-partial-rerender')) return;

    const rerenderId = rerender.id;
    const formId = rerender.getAttribute('observe-form');
    const form = document.getElementById(formId);

    if (!rerenderId || !form || form.dataset.sognaBackorderRerenderGuard) return;

    form.dataset.sognaBackorderRerenderGuard = 'true';
    form.addEventListener('product:rerender', (event) => {
      const currentRerender = document.getElementById(rerenderId);
      const incomingRerender = event.detail?.htmlFragment?.querySelector(`#${CSS.escape(rerenderId)}`);

      if (!currentRerender || !incomingRerender) return;

      const currentHasRequest = Boolean(currentRerender.querySelector(rootSelector));
      const incomingHasRequest = Boolean(incomingRerender.querySelector(rootSelector));

      if (currentHasRequest || incomingHasRequest) {
        currentRerender.removeAttribute('allow-partial-rerender');
      }
    }, { capture: true });
  };

  const bindStickyOpener = (opener) => {
    if (opener.dataset.sognaBackorderOpenerBound) return;

    opener.dataset.sognaBackorderOpenerBound = 'true';
    opener.addEventListener('click', (event) => {
      const panel = document.getElementById(opener.getAttribute('aria-controls'));
      const root = panel?.closest(rootSelector);
      if (!root) return;

      event.preventDefault();
      initialiseRoot(root);
      setPanelState(root, true, { focus: true, scroll: true });
    });
  };

  const initialiseWithin = (node) => {
    if (!(node instanceof Element)) return;

    if (node.matches(rootSelector)) initialiseRoot(node);
    node.querySelectorAll(rootSelector).forEach(initialiseRoot);

    if (node.matches('product-rerender[allow-partial-rerender][observe-form]')) bindRerenderGuard(node);
    node.querySelectorAll('product-rerender[allow-partial-rerender][observe-form]').forEach(bindRerenderGuard);

    if (node.matches('[data-sogna-backorder-open]')) bindStickyOpener(node);
    node.querySelectorAll('[data-sogna-backorder-open]').forEach(bindStickyOpener);
  };

  document.querySelectorAll(rootSelector).forEach(initialiseRoot);
  document.querySelectorAll('product-rerender[allow-partial-rerender][observe-form]').forEach(bindRerenderGuard);
  document.querySelectorAll('[data-sogna-backorder-open]').forEach(bindStickyOpener);

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-sogna-backorder-toggle]');
    if (toggle) {
      const root = toggle.closest(rootSelector);
      if (!root) return;

      event.preventDefault();
      initialiseRoot(root);
      setPanelState(root, toggle.getAttribute('aria-expanded') !== 'true', { focus: true });
      return;
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.sogna-backorder__form');
    if (!form) return;

    const root = form.closest(rootSelector);
    if (root) pushEvent('backorder_request_submit', root);
  });

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach(initialiseWithin));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
